import DatePicker from 'components/Common/DatePicker';
import TimePicker from 'components/Common/TimePicker';
import { combineDate, combineTime } from 'utils/helpers';

interface DateAndTimePickerTypes {
    date: string | Date;
    setDateAndTime: (date: string) => void;
    defaultNull?: boolean;
    disableDate?: boolean;
    disableTime?: boolean;
    dateLabel?: string;
    timeLabel?: string;
    helperText?: string;
    error?: boolean;
}

const DateAndTimePicker = ({
    date,
    setDateAndTime,
    defaultNull,
    disableTime,
    disableDate,
    dateLabel,
    timeLabel,
    helperText,
    error,
}: DateAndTimePickerTypes) => {
    const defaultProps = {
        value: date,
        defaultNull,
        error,
        helperText,
    };

    const handleDateChange = (newDate: string | Date) => {
        const combinedDateTime = combineDate(date, newDate);
        if (!combinedDateTime) {
            return;
        }
        setDateAndTime(combinedDateTime);
    };

    const handleTimeChange = (newTime: string | Date) => {
        const combinedDateTime = combineTime(date, newTime);
        if (!combinedDateTime) {
            return;
        }
        setDateAndTime(combinedDateTime);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 4 }}>
            <DatePicker {...defaultProps} setValue={handleDateChange} disabled={disableDate} label={dateLabel} />
            <TimePicker {...defaultProps} setValue={handleTimeChange} disabled={disableTime} label={timeLabel} />
        </div>
    );
};

export default DateAndTimePicker;
